"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
/**
 * The API definition, which can be used to spawn
 * many invocations of this particular API. Internally
 * this class may do things like caching WASM bytecode, spawning
 * worker threads, or indexing into resolvers to find the requested method.
 */
var Api = /** @class */ (function () {
    function Api() {
    }
    return Api;
}());
exports.Api = Api;
//# sourceMappingURL=Api.js.map